import React from "react";
import noImage from "../data/images/no-image1.jpeg";
import RoomIcons from "./RoomIcons";
import { FaEye } from "react-icons/fa";
import { useStateContext } from "../contexts/ContextProvider";
import AlertBox from "./AlertBox";

const RoomsCard = (props) => {
  const { rooms, setCurrentRoomId, currentPropertyId } = props;
  const { user, leases, handleModal, alert, handleAlert } = useStateContext();

  const sortedRooms = rooms.sort((a, b) =>
    a.roomName.toLowerCase() > b.roomName.toLowerCase() ? 1 : -1
  );

  const currentPropertyLeases = leases.filter(
    (x) => x.propertyId === currentPropertyId
  );

  return (
    <>
      {alert.manageBills && (
        <AlertBox
          alertType="manageBills"
          handleAlert={handleAlert}
          alertFunc={() => {}}
        />
      )}
      {alert.manageChores && (
        <AlertBox
          alertType="manageChores"
          handleAlert={handleAlert}
          alertFunc={() => {}}
        />
      )}
      <div className="w-full md:max-w-[700px]">
        <div className="flex justify-between mt-5 px-5">
          <div
            className="text-center text-blue-500
             hover:text-blue-700 cursor-pointer"
            onClick={() =>
              currentPropertyLeases.length
                ? handleModal("manageBills")
                : handleAlert("manageBills")
            }
          >
            Bills
          </div>
          <div
            className="text-center text-blue-500
             hover:text-blue-700 cursor-pointer"
            onClick={() =>
              currentPropertyLeases.length
                ? handleModal("manageChores")
                : handleAlert("manageChores")
            }
          >
            Chores
          </div>
          <div
            className="text-center text-blue-500
             hover:text-blue-700 cursor-pointer"
            onClick={() =>
              currentPropertyLeases.length
                ? handleModal("manageExpenses")
                : handleAlert("manageExpenses")
            }
          >
            Expenses
          </div>
        </div>
        <ul className="w-full overflow-y-auto border-gray-300 border-1 rounded-xl p-2 mt-2 mb-40">
          {sortedRooms.map((room, index) => {
            return (
              <li
                key={index}
                onClick={() => {
                  handleModal("manageRoom");
                  setCurrentRoomId(room.id);
                }}
              >
                <div
                  className={`flex min-h-28 border-gray-400 hover:border-snappily-orange border-2 rounded-md 
              drop-shadow-md my-2 ${
                user.hasPublished
                  ? ""
                  : "animate-border-pulse hover:animate-none"
              }`}
                >
                  <img
                    src={
                      room.images[0] instanceof Blob
                        ? URL.createObjectURL(room.images[0])
                        : room.images[0] || noImage
                      //remove this logic once image handling is setup
                    }
                    alt={room.roomName}
                    className="h-28  min-w-28 w-28 object-cover border-black border-r-1"
                  />
                  <div className="grid w-full">
                    <div className="flex w-full justify-between pl-2 capitalize">
                      <div>{room.roomName}</div>
                      {room.isPublished && (
                        <div className="text-xl pt-0.5 pr-1">
                          <FaEye />
                        </div>
                      )}
                    </div>
                    <div className="w-48 text-xl pl-2">
                      <RoomIcons
                        currentRoom={room}
                        lease={currentPropertyLeases.find(
                          (x) => x.roomId === room.id
                        )}
                      />
                    </div>
                    <div className="flex justify-between items-end pl-2 pr-1 capitalize">
                      <div>
                        {/* if room has active leases */}
                        {currentPropertyLeases.find(
                          (x) => x.roomId === room.id
                        ) &&
                          (leases.find((x) => x.roomId === room.id).status ===
                          "active" ? (
                            <span className="text-green-500">
                              {
                                currentPropertyLeases.find(
                                  (x) => x.roomId === room.id
                                ).status
                              }
                            </span>
                          ) : leases.find((x) => x.roomId === room.id)
                              .status === "created" ? (
                            <span className="text-yellow-500">
                              {
                                currentPropertyLeases.find(
                                  (x) => x.roomId === room.id
                                ).status
                              }
                            </span>
                          ) : (
                            <span className="text-blue-300">
                              {
                                currentPropertyLeases.find(
                                  (x) => x.roomId === room.id
                                ).status
                              }
                            </span>
                          ))}

                        {/* if room has no active leases */}
                        {!currentPropertyLeases.find(
                          (x) => x.roomId === room.id
                        ) && <span className="text-red-400">Vacant</span>}
                      </div>
                      <div>Rent: ${Intl.NumberFormat().format(room.rent)}</div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default RoomsCard;
